import React from 'react';
import './sidebar-user-card.css';

function resolveUser(user) {
  const rawName = user?.fullName || user?.full_name || user?.name || user?.username || 'User';
  const displayName = String(rawName).trim();
  const roleRaw = String(user?.role || 'User').trim();
  const specRaw = String(
    user?.specialization ||
    user?.specialization_name ||
    user?.speciality ||
    user?.specialty ||
    user?.doctor_specialization ||
    user?.department ||
    ''
  ).trim();
  const role = roleRaw.toLowerCase();
  const spec = specRaw.toLowerCase();

  let designation = roleRaw || 'User';
  if (role.includes('company admin')) {
    designation = 'Administrator';
  } else if (spec.includes('surg')) {
    designation = 'Surgeon';
  } else if (role.includes('admin')) {
    designation = 'Administrator';
  }

  const initial = displayName.charAt(0) || 'U';
  return { displayName, role: designation, initial };
}

export default function SidebarUserCard({ user, onProfile, onChangePassword, onSignout }) {
  const [open, setOpen] = React.useState(false);
  const cardRef = React.useRef(null);
  const { displayName, role, initial } = resolveUser(user || {});

  React.useEffect(() => {
    const onDocClick = (ev) => {
      if (cardRef.current && cardRef.current.contains(ev.target)) return;
      setOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, []);

  return (
    <div className="sidebar-user-wrap" ref={cardRef}>
      <button type="button" className="sidebar-user-trigger" onClick={() => setOpen((v) => !v)}>
        <span className="sidebar-user-avatar">{initial}</span>
        <span className="sidebar-user-meta">
          <span className="sidebar-user-name">{displayName}</span>
          <span className="sidebar-user-role">{role}</span>
        </span>
        <span className="sidebar-user-caret">{open ? '▲' : '▼'}</span>
      </button>

      {open && (
        <div className="sidebar-user-menu" role="menu" aria-label="User actions">
          <button type="button" className="sidebar-user-menu-item" onClick={() => { onProfile && onProfile(); setOpen(false); }}>Profile</button>
          <button type="button" className="sidebar-user-menu-item" onClick={() => { onChangePassword && onChangePassword(); setOpen(false); }}>Change Password</button>
          <button type="button" className="sidebar-user-menu-item danger" onClick={() => { onSignout && onSignout(); setOpen(false); }}>Signout</button>
        </div>
      )}
    </div>
  );
}
